var map = {
	"./area.js": "Z0Kw",
	"./auth.js": "D+VX",
	"./banner.js": "cHlS",
	"./cart.js": "u3Ct",
	"./config.js": "47GS",
	"./delivery.js": "YyVm",
	"./dialog.js": "1RWN",
	"./dine_mode.js": "Uj6w",
	"./member.js": "xwjM",
	"./menu.js": "egBL",
	"./message.js": "oMgr",
	"./order.js": "yEsQ",
	"./promo.js": "MEiJ",
	"./receipt.js": "Pxkc",
	"./takeaway.js": "LHoy",
	"./voucher.js": "HwpZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IeuG";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive .*\.js$
// module id = IeuG
// module chunks = 0